// 语言代码映射
export const isoCodeMap = {
  zh: 'zhCN',
  'zh-CN': 'zhCN',
  'zh-TW': 'zhTW',
}

// 获取页面语言代码
export const getPageLangCode = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const language = urlParams.get('language') || urlParams.get('lang') || navigator.language
  return isoCodeMap[language] || language
}
